import cn from "classnames";

import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import EditableLink from "@components/cms/EditableLink/EditableLink";
import { EDITABLE_LINK_VARIANTS } from "@config/cms";
import Container from "@ui-kit/Container/Container";

import s from "./ButtonBlock.module.scss";

const ButtonBlock = ({ data, updateField, settings }) => {
  const { title = "", link, showMore } = data;
  const { blockType } = settings.common;
  const { position, buttonStyle } = settings.specific;

  const positionLinkValue = position?.value;
  const buttonStyleValue = buttonStyle?.value ?? "primary";
  const isBackLinkStyle = buttonStyleValue === "backLink";

  const updateShowMoreLink = (value) => {
    updateField({
      name: "link",
      value,
    });
  };

  return (
    <Container className={s.container}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          <div className={cn(s.buttonContainer, s[positionLinkValue])}>
            <EditableLink
              link={link}
              data={showMore}
              isButtonTypeLink={!isBackLinkStyle}
              variant={
                isBackLinkStyle
                  ? EDITABLE_LINK_VARIANTS.back
                  : EDITABLE_LINK_VARIANTS.forward
              }
              position={positionLinkValue}
              onChange={updateShowMoreLink}
              className={cn(s.showMore, s[positionLinkValue])}
            />
          </div>
        </section>
      </Container>
    </Container>
  );
};

export default ButtonBlock;
